import "./ReportOrariMagazziniere.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import FiltroCategorie from "../../components/FiltroCategorie/FiltroCategorie.js";
import Impianti from "./Impianti/Impianti";
import Spedizioni from "./Spedizioni/Spedizioni";
import ImpiantiStatiIntermedi from "./ImpiantiStatiIntermedi/ImpiantiStatiIntermedi";
import SpedizioniStatiIntermedi from "./SpedizioniStatiIntermedi/SpedizioniStatiIntermedi";

const ROM_CATEGORIES = ["Impianti", "Spedizioni", "Impianti - Stati intermedi", "Spedizioni - Stati intermedi"];

const ReportOrariMagazziniere = () => {
    const navigate = useNavigate();
    const [selectedCategory, setSelectedCategory] = useState("");
    const [showInfoModal, setShowInfoModal] = useState(false);

    const handleCategorySelect = (category) => {
        setSelectedCategory(category);
    };

    return (
        <div className="rom-container">
            {/* HEADER */}
            <header className="rom-header">
                <div className="rom-header-content">
                    <button className="rom-back-btn" onClick={() => navigate("/automazione")}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                        Indietro
                    </button>
                    <div className="rom-header-title">
                        <div className="rom-title-row">
                            <h1>Report Orari Magazziniere</h1>
                            <button className="rom-info-btn" onClick={() => setShowInfoModal(true)} title="Informazioni">
                                <span>i</span>
                            </button>
                        </div>
                        <p className="rom-subtitle">Analisi orario di scarichi in impianto</p>
                    </div>
                </div>
            </header>

            {/* MODAL INFO */}
            {showInfoModal && (
                <div className="rom-modal-overlay" onClick={() => setShowInfoModal(false)}>
                    <div className="rom-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="rom-modal-header">
                            <div className="rom-modal-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="12" y1="16" x2="12" y2="12"></line>
                                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                                </svg>
                            </div>
                            <h3>Informazioni sulla pagina</h3>
                            <button className="rom-modal-close" onClick={() => setShowInfoModal(false)}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </button>
                        </div>
                        <div className="rom-modal-body">
                            <div className="rom-modal-section">
                                <h4>Cosa fa questa pagina?</h4>
                                <p>Analizza gli orari di scarico presso gli impianti, mostrando KPI principali e il profilo orario delle operazioni.</p>
                            </div>
                            <div className="rom-modal-section">
                                <h4>Tab disponibili</h4>
                                <ul>
                                    <li><strong>Impianti</strong> - KPI e profilo orario degli scarichi in impianto</li>
                                    <li><strong>Spedizioni</strong> - Analisi delle spedizioni</li>
                                    <li><strong>Impianti - Stati intermedi</strong> - Dettaglio stati intermedi impianti</li>
                                    <li><strong>Spedizioni - Stati intermedi</strong> - Dettaglio stati intermedi spedizioni</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* CONTENT */}
            <div className="content-area">
                <FiltroCategorie
                    categories={ROM_CATEGORIES}
                    filteredCategory={handleCategorySelect}
                    customCss={"reportistica-section"}
                />

                {selectedCategory === "Impianti" && <Impianti />}
                {selectedCategory === "Spedizioni" && <Spedizioni />}
                {selectedCategory === "Impianti - Stati intermedi" && <ImpiantiStatiIntermedi />}
                {selectedCategory === "Spedizioni - Stati intermedi" && <SpedizioniStatiIntermedi />}
            </div>
        </div>
    );
};

export default ReportOrariMagazziniere;
